import ReactMarkdown from 'react-markdown'

import { TextLink } from 'slab'

type FormattedProps = {
  text: string;
  color?: string;
}

export const Formatted = ({ text, color = 'text-gray-500' }: FormattedProps) => {
  const processedDescription = text.replace(/(^)• /gm, '$1- ')

  const baseClasses = {
    p: `mb-4 last:mb-0 ${color}`,
    ul: `mb-4 last:mb-0 list-disc list-outside pl-4 ${color}`,
    ol: `mb-4 last:mb-0 list-decimal list-outside pl-4 ${color}`,
    li: 'mb-1 last:mb-0'
  }

  return (
    <div className='formatted-markdown'>
      <ReactMarkdown
        components={{
          p: (props) => <p className={baseClasses.p} {...props} />,
          ul: ({ children, ...rest }) => (
            <ul className={baseClasses.ul} {...rest}>
              {children}
            </ul>
          ),
          ol: ({ children, ...rest }) => (
            <ol className={baseClasses.ol} {...rest}>
              {children}
            </ol>
          ),
          li: ({ children, ...rest }) => (
            <li className={baseClasses.li} {...rest}>{children}</li>
          ),
          a: ({ children, href, color: _color, ...rest }) => {
            return (
              <TextLink href={href} type='gray' target='_blank' rel='noopener noreferrer' {...rest}>
                {children}
              </TextLink>
            )
          },
        }}
        allowedElements={['a', 'p', 'ul', 'ol', 'li', 'strong', 'em']}
      >
        {processedDescription}
      </ReactMarkdown>
    </div>
  )
}
